<template>
  <SvgIcon icon="notifications" :class="{ active }" />
</template>

<script setup lang="ts">
defineProps<{
  active: boolean
}>()
</script>

<style scoped lang="scss">
svg {
  &.active {
    circle {
      visibility: visible;
    }
  }

  circle {
    visibility: hidden;
  }
}
</style>
